import { generateAisScan, type AisScan } from "./aisScan";
import { generateGlacierCapture, type GlacierCapture } from "./glacierCapture";

/* ------------------------------------------------------------------ *
 * Which commands make the payload produce data, and that data. A command
 * not listed here just completes. Keyed by command code (see
 * supabase/sql/mission_commands.sql and icewatch_command.sql).
 * ------------------------------------------------------------------ */

export type PayloadKind = "ais" | "imaging";

export const PAYLOAD_EFFECTS: Record<string, { payloadName: string; kind: PayloadKind }> = {
  "CMD-6101": { payloadName: "AIS receiver", kind: "ais" },
  "CMD-6201": { payloadName: "Multispectral imager", kind: "imaging" },
};

export type PayloadResult =
  | { kind: "ais"; areaName: string; dataKb: number; units: number; unitLabel: string; data: AisScan }
  | { kind: "imaging"; areaName: string; dataKb: number; units: number; unitLabel: string; data: GlacierCapture };

// The result of a command for a group; `seed` keeps it the same for all
// the group's members.
export function payloadResultFor(kind: PayloadKind, seed: number): PayloadResult {
  if (kind === "ais") {
    const data = generateAisScan(seed);
    return { kind, areaName: data.area.name, dataKb: data.dataKb, units: data.totalMessages, unitLabel: "AIS messages", data };
  }
  const data = generateGlacierCapture(seed);
  return {
    kind,
    areaName: `${data.target.name}, ${data.target.region}`,
    dataKb: data.dataKb,
    units: data.frames * data.bands.length,
    unitLabel: "images",
    data,
  };
}

// "512 KB" / "36.0 MB"
export function formatDataSize(kb: number): string {
  return kb >= 1024 ? `${(kb / 1024).toFixed(1)} MB` : `${Math.round(kb)} KB`;
}
